import request from './base'

export const uploadSign = (data) => {
    return request.post("/admin/v1/upload/uploadSign", data)
}

export const upPutFile = (url, params, callBack, type) => {
    return request.uploadPutFile(url, params, callBack, type)
}

export const downloadFile = (data) => {
    return request.post("/admin/v1/upload/downloadFile", data)
}


// WEBPACK FOOTER //
// ./src/api/upload.js